export const getRoundIDs = state => state.rounds.ids;
export const getRoundByID = id => state => state.rounds.list_MODERN[id];
export const getRounds = state => Object.values(state.rounds.list_MODERN);
export const getRoundStatusByID = id => state => state.rounds.status[id];
